import React, {useState} from 'react';
import {connect} from 'react-redux';
import Numeral from 'numeral';
import {clearVehicleDetails} from '../actions/vehicleAds';
import {getDiffrentTime} from '../utils/DateUtility'
import {enToFa} from '../utils/NumberUtility'
import logo from '../assets/images/C_logo.png';
import ModalComponent from '../components/ModalComponent';
import {startElevateVehicle} from '../actions/dashboard';
import {startDeleteVehicle} from '../actions/vehicleAds';

const VehicleAdItem = (props) => {

  const [noElevator, setNoElevator] = useState(false);
  const [elevatorSuccess, setElevatorSuccess] = useState(false);
  const [deleteConfirm, setDeleteConfirm] = useState(false);

  const handleCloseNoElevatorModal = (e) => {
    setNoElevator(false);
  }

  const handleCloseElevatorSuccessModal = (e) => {
    setElevatorSuccess(false);
  }

  const handleCloseRemoveModal = (e) => {
    setDeleteConfirm(false);
  }

    const onItemSelected = (e) => {
      props.clearVehicleDetails()
      props.push(`/vehicle/${props.info.id}`)
    }

    const onElevateClicked = (e) => {
      if (props.elevatorCount > 0){
        props.startElevateVehicle(props.info.id)
        .then(({success, error}) => {
                if (success){
                    setElevatorSuccess(true)
                }
                else{
                }
            })
      }
      else {
        setNoElevator(true)
      }
    }

    const onTrashClicked = (e) => {
      setDeleteConfirm(true)
    }
    
    const handleSubmitRemoveModal = (e) => {
      props.startDeleteVehicle(props.info.id)
    }

    return (
      <div className={`vehicle-ad mb-3 ${props.classes ? props.classes : '' }`}>
        <div className="optimized__d-flex-class">
          < img className = "vehicle-ad__img col-4 px-2" onClick={onItemSelected}
          src = {
            props.info.images.length < 1 ? logo : props.sharedElement ? `https://prv.carclick.ir${props.info.images[0].image}` : props.info.images[0].image
          }
          />
          <div className="optimized__d-flex-class flex-column col-8 justify-content-between" onClick={onItemSelected}>
            <span className="vehicle-ad__title">{`${props.sharedElement ? props.info.info.brand.name : props.info.vehicle.brand.name} ${props.sharedElement ? props.info.info.name : props.info.vehicle.name}`}</span>
            <span className="vehicle-ad__elapsed-time optimized__d-flex-class">
              <span><i className="simple-icon-clock vehicle-ad__elapsed-logo"></i></span><span>{enToFa(getDiffrentTime(props.info.modificationDate))}</span>
            </span>
            <div className="optimized__d-flex-class flex-row-reverse justify-content-between align-items-center">
              <span className="vehicle-ad__price-type">{props.info.type.name}</span>
              {
                props.info.type.name !== 'توافقی' ? (
                  <span className="vehicle-ad__price">{`${enToFa(Numeral(props.info.price).format('0,0'))} تومان`}</span>
                ) : (undefined)
              }
            </div>
          </div>
          <ModalComponent
              onRequestClose={handleCloseNoElevatorModal}
              isOpen={noElevator}>
              <div className="dashboard__info-modal d-flex flex-column flex-grow-1">
                  <span>لطفا ابتدا آسانسور تهیه کنید.</span>
                  <div className="optimized__d-flex-class justify-content-end pt-3">
                      <button className="btn__close m-0" onClick={handleCloseNoElevatorModal}>بستن</button>
                  </div>
              </div>
          </ModalComponent>
          <ModalComponent
              onRequestClose={handleCloseElevatorSuccessModal}
              isOpen={elevatorSuccess}>
              <div className="dashboard__info-modal d-flex flex-column flex-grow-1">
                  <span>آگهی شما با موفقیت آسانسور شد.</span>
                  <div className="optimized__d-flex-class justify-content-end pt-3">
                      <button className="btn__close m-0" onClick={handleCloseElevatorSuccessModal}>بستن</button>
                  </div>
              </div>
          </ModalComponent>
          <ModalComponent
              onRequestClose={handleCloseRemoveModal}
              isOpen={deleteConfirm}>
              <div className="dashboard__info-modal d-flex flex-column flex-grow-1">
                  <span>آیا از حذف آگهی اطمینان دارید؟</span>
                  <div className="optimized__d-flex-class justify-content-end pt-3">
                      <button className="btn__close--secondary mx-2" onClick={handleCloseRemoveModal}>انصراف</button>
                      <button className="btn__close mx-0" onClick={handleSubmitRemoveModal}>حذف</button>
                  </div>
              </div>
          </ModalComponent>
        </div>
        <div className="optimized__d-flex-class justify-content-start align-items-center mt-2">
            <span>
              <i className="simple-icon-location-pin vehicle-ad__location-logo"></i>
            </span>
          <span className="vehicle-ad__location" onClick={onItemSelected}>{props.sharedElement ? props.info.area : `${props.info.city.state.name}، ${props.info.city.name}`}</span>
          {
            props.dashboardType ? (
              <div>
                <span><i class="material-icons stock__i" onClick={onTrashClicked}>delete</i></span>
                <i class="material-icons stock__i" onClick={onElevateClicked}>trending_up</i>
              </div>
            ) : undefined
          }
        </div>
        {!props.sharedElement ? (
          <div className="optimized__d-flex-class justify-content-between align-items-center">
            <span className="vehicle-ad__description">{`سال ساخت: ${enToFa(props.info.yearModel)}`}</span>
            <span className="vehicle-ad__description">{`وضعیت بیمه: ${enToFa(props.info.insuranceStatus.name)}`}</span>
          </div>
        ): (undefined)}
      </div>
    );
}

const mapStateToProps = (state, props) => ({
    elevatorCount: state.auth.info.elevators
})

const mapDispatchToProps = (dispatch) => ({
  clearVehicleDetails: () => dispatch(clearVehicleDetails()),
  startElevateVehicle: (id) => dispatch(startElevateVehicle(id)),
  startDeleteVehicle: (id) => dispatch(startDeleteVehicle(id))
})

export default connect(mapStateToProps, mapDispatchToProps)(VehicleAdItem);